import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'sortByLabel'
})
export class sortByLabelPipe implements PipeTransform {

    transform(value: any[]): any[] {

        const sorted = value.sort((n1, n2) => {

            if (n1?.mapLocalLibelle?.['fr_FR'] && n2?.mapLocalLibelle?.['fr_FR']) {
                return n1.mapLocalLibelle['fr_FR'].localeCompare(n2.mapLocalLibelle['fr_FR'])
            };

            if (n1?.valeur && n2?.valeur) {
                return n1.valeur.localeCompare(n2.valeur)
            }

            return -1;

        });

        return sorted;
    }
}